import { CdkCellDef } from '@angular/cdk/table';
import { Directive, Input } from '@angular/core';
import { Observable } from 'rxjs';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[cdkCellDef]', // same selector as MatCellDef
  providers: [
    { provide: CdkCellDef, useExisting: TypeSafeMatCellDefDirective },
  ],
  standalone: false,
})
export class TypeSafeMatCellDefDirective<T> extends CdkCellDef {
  // leveraging syntactic-sugar syntax when we use *matCellDef
  @Input({ required: true }) cdkCellDefDataSource!: T[] | Observable<T[]>;

  // ngTemplateContextGuard flag to help with the Language Service
  public static ngTemplateContextGuard<T>(
    dir: TypeSafeMatCellDefDirective<T>,
    ctx: unknown
  ): ctx is { $implicit: T; index: number; first: boolean; last: boolean } {
    return true;
  }
}
